<!-- Page Header -->
<app-page-header></app-page-header>
<app-style-view [mainColor]="'#00733f'"></app-style-view>

<!-- Main Content -->
<div class="container py-2">
  <div class="row py-4">

    <!-- Contact Form -->
    <div class="col-lg-6">
      <div class="overflow-hidden mb-1">
        <h2 class="font-weight-normal text-7 mt-0 mb-0">
          <strong class="font-weight-extra-bold">{{ 'CONTACT_TITLE' | translate }}</strong>
        </h2>
      </div>

      <form id="contactForm" class="contact-form" (ngSubmit)="submitContact()" #contactForm="ngForm">

        <!-- Success Message -->
        @if (contactResult === true) {
          <div class="alert alert-success">
            {{ 'CONTACT_SUCCESS' | translate }}
          </div>
        }

        <!-- Error Message -->
        @if (contactResult === false) {
          <div class="alert alert-danger">
            {{ 'CONTACT_ERROR' | translate }}
          </div>
        }

        <!-- Name and Email Row -->
        <div class="form-row">
          <div class="form-group col-lg-6">
            <mat-form-field appearance="outline" class="contact-input">
              <mat-label class="required font-weight-bold text-dark text-2">
                {{ 'CONTACT_NAME' | translate }}
              </mat-label>
              <input
                matInput
                type="text"
                [value]="contactData.name"
                maxlength="100"
                name="name"
                id="name"
                required
                [disabled]="isSubmitting"
                (input)="onInputChange('name', $any($event.target).value)" />
              </mat-form-field>
            </div>
            <div class="form-group col-lg-6">
              <mat-form-field appearance="outline" class="contact-input">
                <mat-label class="required font-weight-bold text-dark text-2">
                  {{ 'CONTACT_EMAIL' | translate }}
                </mat-label>
                <input
                  matInput
                  type="email"
                  [value]="contactData.mail"
                  maxlength="100"
                  name="email"
                  id="email"
                  required
                  [disabled]="isSubmitting"
                  (input)="onInputChange('mail', $any($event.target).value)" />
                </mat-form-field>
              </div>
            </div>

            <!-- Subject Row -->
            <div class="form-row">
              <div class="form-group col">
                <mat-form-field appearance="outline" class="contact-input">
                  <mat-label class="font-weight-bold text-dark text-2">
                    {{ 'CONTACT_SUBJECT' | translate }}
                  </mat-label>
                  <input
                    matInput
                    type="text"
                    [value]="contactData.subject"
                    maxlength="100"
                    name="subject"
                    id="subject"
                    required
                    [disabled]="isSubmitting"
                    (input)="onInputChange('subject', $any($event.target).value)" />
                  </mat-form-field>
                </div>
              </div>

              <!-- Message Row -->
              <div class="form-row">
                <div class="form-group col">
                  <mat-form-field appearance="outline" class="contact-input">
                    <mat-label class="required font-weight-bold text-dark text-2">
                      {{ 'CONTACT_MESSAGE' | translate }}
                    </mat-label>
                    <textarea
                      matInput
                      maxlength="5000"
                      rows="4"
                      name="message"
                      id="message"
                      required
                      [value]="contactData.message"
                      [disabled]="isSubmitting"
                      (input)="onInputChange('message', $any($event.target).value)">
                    </textarea>
                  </mat-form-field>
                </div>
              </div>

              <!-- Submit Button Row -->
              <div class="form-row">
                <div class="form-group col">
                  <button
                    type="submit"
                    class="btn btn-primary btn-modern"
                    [disabled]="isSubmitting || !contactForm.valid">
                    @if (isSubmitting) {
                      <span class="spinner-border spinner-border-sm me-2" role="status"></span>
                    }
                    {{ 'CONTACT_BTN' | translate }}
                  </button>
                </div>
              </div>
            </form>
          </div>

          <!-- Contact Information -->
          <div class="col-lg-6">
            <div class="contact-info">
              <h4 class="mt-2 mb-1">{{ 'CONTACT_TITLE2' | translate }}</h4>
              <ul class="list list-icons list-icons-style-2 mt-2" style="padding-left:0; list-style:none;">
                <li style="display: flex; align-items: flex-start; margin-bottom: 12px;">
                  <span style="width: 28px; display: flex; justify-content: center; align-items: flex-start;">
                    <i class="fas fa-map-marker-alt top-6"></i>
                  </span>
                  <span>
                    <strong class="text-dark">{{ 'CONTACT_ADDRESS' | translate }}:</strong>
                    Istanbul Universitesi Rektorlugu 34452 Beyazıt / Fatih / Istanbul
                  </span>
                </li>
                <li style="display: flex; align-items: flex-start; margin-bottom: 12px;">
                  <span style="width: 28px; display: flex; justify-content: center; align-items: flex-start;">
                    <i class="fas fa-phone top-6"></i>
                  </span>
                  <span>
                    <strong class="text-dark">{{ 'CONTACT_PHONE' | translate }}:</strong>
                    +90 212 440 00 00
                  </span>
                </li>
                <li style="display: flex; align-items: flex-start; margin-bottom: 12px;">
                  <span style="width: 28px; display: flex; justify-content: center; align-items: flex-start;">
                    <i class="fas fa-envelope top-6"></i>
                  </span>
                  <span>
                    <strong class="text-dark">{{ 'CONTACT_EMAIL' | translate }}:</strong>
                    <a href="mailto:iupress@istanbul.edu.tr" target="_blank">iupress&#64;istanbul.edu.tr</a>
                  </span>
                </li>
              </ul>
            </div>
          </div>

        </div>
      </div>
